export default __webpack_public_path__ + "static/media/vi_Gastronomia.393e3443.mp4";